import { render, staticRenderFns } from "./CardTrend.vue?vue&type=template&id=515c899f&scoped=true"
import script from "./CardTrend.vue?vue&type=script&lang=ts"
export * from "./CardTrend.vue?vue&type=script&lang=ts"
import style0 from "./CardTrend.vue?vue&type=style&index=0&id=515c899f&prod&global=true&lang=css"
import style1 from "./CardTrend.vue?vue&type=style&index=1&id=515c899f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c899f",
  null
  
)

export default component.exports